import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=72b6310e&scoped=true"
import script from "./selectGoods.vue?vue&type=script&lang=js"
export * from "./selectGoods.vue?vue&type=script&lang=js"
import style0 from "./selectGoods.vue?vue&type=style&index=0&id=72b6310e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6310e",
  null
  
)

export default component.exports